import React from 'react';
import { TableCell, TableHead, TableRow, useTheme } from '@mui/material';

const TableHeader = () => {
  const theme = useTheme();
  return (
    <TableHead>
      <TableRow
        sx={{
          backgroundColor: theme.palette.primary.main,
          '& th': {
            color: theme.palette.common.white,
            fontWeight: '600',
            letterSpacing: '0.5px',
            px: { xs: 1, sm: 2, md: 3 },
          },
        }}
      >
        <TableCell sx={{ width: '60px' }} />
        <TableCell>User Name</TableCell>
        <TableCell align="left">Email</TableCell>
        <TableCell align="left">Role</TableCell>
        <TableCell align="left">Utm / Location</TableCell>
        <TableCell align="right">CreatedAt</TableCell>
        <TableCell align="right" sx={{ width: '140px' }}>
          Action
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;